import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatDividerModule } from '@angular/material/divider'
import { MatIconModule } from '@angular/material/icon'
import { MatMenuModule } from '@angular/material/menu'
import { TranslateModule } from '@ngx-translate/core'

import { BalanceSendChannel } from '../../../balance-summary.types'
import { ModifySessionPhase } from '../../../services/estimate-balance-presenter.service'

@Component({
  selector: 'mmx-modify-session-action-bar',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule, MatButtonModule, MatDividerModule, MatIconModule, MatMenuModule],
  templateUrl: './modify-session-action-bar.component.html',
  styleUrls: ['./modify-session-action-bar.component.scss'],
})
export class ModifySessionActionBarComponent {
  @Input() phase: ModifySessionPhase = 'finalized'
  @Input() canModify = false
  @Input() canCalculate = false
  @Input() canFinalize = false
  @Input() canSend = false
  @Input() canSendEmail = false
  @Input() canSendSms = false
  @Input() canSendDocument = false
  @Input() canPrintLetter = false
  @Input() canViewHistory = false
  @Input() canVoid = false
  @Input() busy = false

  @Output() readonly modify = new EventEmitter<void>()
  @Output() readonly discard = new EventEmitter<void>()
  @Output() readonly calculate = new EventEmitter<void>()
  @Output() readonly finalize = new EventEmitter<void>()
  @Output() readonly send = new EventEmitter<BalanceSendChannel>()
  @Output() readonly sendDocument = new EventEmitter<void>()
  @Output() readonly printLetter = new EventEmitter<void>()
  @Output() readonly viewHistory = new EventEmitter<void>()
  @Output() readonly void = new EventEmitter<void>()

  emit<T>(out: EventEmitter<T>, payload: T): void {
    if (this.busy) return
    out.emit(payload)
  }

  emitVoid(out: EventEmitter<void>): void {
    if (this.busy) return
    out.emit()
  }
}
